import { AdminRouter, AdminSidebar } from 'stylemix-vue-admin'
import { messageGroups } from '../plugins/i18n'

const base = 'reviews'

AdminRouter.addRoute({
  name: `${base}.list`,
  path: `/drivers/:id/reviews`,
  component: () => import('./Index.vue'),
  meta: {
    auth: true,
  },
})
AdminRouter.addRoute({
  name: `${base}.all`,
  path: `/reviews`,
  component: () => import('./Index.vue'),
  meta: {
    auth: true,
  },
})
AdminRouter.addRoute({
  name: `${base}.edit`,
  path: `/${base}/:id`,
  component: () => import('./Edit.vue'),
  meta: {
    auth: true,
  },
})

AdminSidebar.pushItem({
  id: `${base}`,
  header: $vm => $vm.$t(`general.menu_management`),
  text: $vm => $vm.$t(`reviews.label_driver_rating`),
  route: {
    name: `${base}.all`,
  },
  icon: 'icon-bubbles2',
  permission: $vm => {
    return $vm.$allows('administer') || ($vm.$account && $vm.$account.company)
  },
})

messageGroups.push(base)
